import { SvgIconProps } from './icon-props';

export default function IconTime({ fill = 'none', height = 25, role, width = 26 }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 26 25"
			fill={fill}
			role={role}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.98438 3.43323C8.34756 2.52161 9.89602 1.92377 11.5181 1.68282C13.1403 1.44186 14.7956 1.56379 16.3649 2.03982C17.9343 2.51584 19.3784 3.3341 20.5933 4.43562C21.8082 5.53714 22.7636 6.89447 23.3906 8.40979C23.9501 9.75402 24.2369 11.196 24.2344 12.652C24.2336 14.5668 23.7369 16.4487 22.7926 18.1145C21.8483 19.7802 20.4887 21.173 18.8462 22.1572C17.2036 23.1413 15.3342 23.6832 13.42 23.7301C11.5057 23.777 9.61202 23.3273 7.92326 22.4248C6.2345 21.5223 4.80829 20.1977 3.78357 18.5802C2.75886 16.9627 2.17057 15.1073 2.07602 13.1949C1.98148 11.2824 2.3839 9.37806 3.24408 7.66735C4.10426 5.95665 5.39287 4.4979 6.98438 3.43323ZM7.35156 21.3317C8.77874 22.2834 10.4181 22.8695 12.1251 23.0384C13.8322 23.2074 15.5546 22.9539 17.1406 22.3004C18.407 21.7721 19.5586 21.0026 20.5313 20.0348C22.0528 18.5134 23.067 16.559 23.435 14.439C23.803 12.3191 23.5069 10.1372 22.5871 8.19201C21.6673 6.24685 20.1688 4.63349 18.2967 3.57277C16.4247 2.51206 14.2705 2.05583 12.1292 2.26653C9.98788 2.47724 7.964 3.34458 6.3346 4.74984C4.70519 6.1551 3.54991 8.02958 3.02688 10.1167C2.50385 12.2039 2.63864 14.4016 3.4128 16.4092C4.18696 18.4168 5.56265 20.1361 7.35156 21.3317ZM12.8203 14.0192V6.80042H13.5234V13.2848H19.1328V13.9957L12.8203 14.0192Z"
				fill="#030303"
			/>
		</svg>
	);
}
